export const SRM_ANTRAG_LINK =
	'https://itsm-dwp.helix.porsche.services/dwp/app/#/itemprofile/409';
